// src/utils/emailFanout.js
// Send one email to EVERY client on a file, not just one. Pure helpers shared by
// the portal-forms sends and the deal-detail "Send by email" so the fan-out rule
// lives in one place: de-dupe + drop blanks, first recipient as `to`, the rest
// bcc'd (co-clients on one file don't see each other's addresses).

export const pickEmail = (c) => String(c?.email || c?.clientEmail || "").trim();
export const pickName = (c) =>
  c?.name ||
  c?.clientName ||
  c?.fullName ||
  [c?.firstName, c?.lastName].filter(Boolean).join(" ") ||
  "";

// Unique, non-blank emails from a list of contact objects, order preserved.
export function emailsForContacts(contacts) {
  const seen = new Set();
  const out = [];
  (Array.isArray(contacts) ? contacts : []).forEach((c) => {
    const e = pickEmail(c);
    const key = e.toLowerCase();
    if (e && !seen.has(key)) {
      seen.add(key);
      out.push(e);
    }
  });
  return out;
}

// { to, bcc, all } for sendTransactionEmail — first recipient visible, the rest
// bcc'd as a comma-joined string (the send-email backend's Bcc header). Dedupes
// defensively so a caller can pass a raw list.
export function splitToBcc(emails) {
  const seen = new Set();
  const uniq = [];
  (Array.isArray(emails) ? emails : []).forEach((raw) => {
    const e = String(raw || "").trim();
    const key = e.toLowerCase();
    if (e && !seen.has(key)) {
      seen.add(key);
      uniq.push(e);
    }
  });
  return { to: uniq[0] || "", bcc: uniq.slice(1).join(","), all: uniq };
}
